import React from 'react';
import * as Styled from './ResultStandard.styled';
import AudioPlayer from '../AudioPlayer/AudioPlayer';
import ImagePreview from '../ImagePreview/ImagePreview';
import VideoPreview from '../VideoPreview/VideoPreview';
import ResultText from '../../atoms/ResultText/ResultText';

const ResultStandard = (props) => {
  return (
    <Styled.Wrapper>
      {props.resultItem.text &&
        !['audio', 'video', 'image'].includes(props.resultItem.text) && (
          <ResultText>{props.resultItem.text}</ResultText>
        )}
      {props.resultItem.image && <ImagePreview file={props.resultItem.image} />}
      {props.resultItem.audio && <AudioPlayer file={props.resultItem.audio} />}
      {props.resultItem.video && <VideoPreview file={props.resultItem.video} />}
    </Styled.Wrapper>
  );
};

ResultStandard.propTypes = {};

export default ResultStandard;
